<template>
  <div class="container">
    <my-task-datatable />
  </div>
</template>

<script>
import MyTaskDatatable from "./my_task_datatable/Index.vue";

export default {
  name: "CentralDispatchTrackerMyTasks",
  components: { MyTaskDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {},
    refresh() {},
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
